<template>
  <main>
    <vue-headful
      title="Testez votre niveau de japonais"
      description="Évaluez votre niveau de japonais et trouvez le cours qui vous correspond. Test gratuit, résultat immédiat, sans création de compte."
      url="https://adlcj.fr/cours-japonais/niveau"
      site_name="ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises"
      type="article"
    />
    <section class="title">
      <div class="title-wrapper">
        <h1>Testez votre niveau de japonais</h1>
      </div>
      <p>
        Évaluez votre niveau de japonais et trouvez le cours qui vous correspond.</p>

      <ul>
        <li><strong>Gratuit</strong></li>
        <li>Aucun création de compte nécessaire</li>
        <li>Résultat immédiat</li>
      </ul>


    </section>
    <div class="infoNote">
      <p>
      <img src="../assets/image/icons/emojione_information.svg" alt="" aria-hidden="true" class="infoIcon" />Lorsque
      plusieurs niveaux correspondent à votre résultat, nous vous recommandons de choisir le niveau le plus accessible.
      Il est possible de changer de classe après le début des cours, si nécessaire. 
      </p>
      <p>
      <img src="../assets/image/icons/emojione_information.svg" alt="" aria-hidden="true" class="infoIcon" />Le résultat
      obtenu sert d’indication et ne détermine pas définitivement votre niveau de classe.
      </p>
      <p class="checklistTitle">
        <img src="../assets/image/icons/emojione_light-bulb.svg" alt="" aria-hidden="true" class="infoIcon" /> CHECK LIST
        disponible
        </p>
        <p class="checklistNote">
        Pour en savoir plus sur les différents niveaux, consultez également notre
        <a href="/pdf/checklist-minna-no-nihongo.pdf" target="_blank" rel="noopener noreferrer" class="linkWithIcon">
          <img src="../assets/image/icons/jump-link.svg" alt="" aria-hidden="true" class="linkIcon" />check list
        </a>.
      </p>
      <p class="checklistNote checklistNoteStrong">À titre indicatif, il est nécessaire de comprendre à plus de 80 % les textes des leçons précédant celles du niveau que vous envisagez de suivre.</p>
    </div>
    
    
    <niveauQuiz />
    <div class="backBtnWrapper">
      <ButtonSecondary label="Retour" variant="grey" to="/cours-japonais" class="backBtn" />
    </div>
  </main>
</template>

<script>
import NiveauQuiz from '../components/niveauQuiz.vue'
import ButtonSecondary from '../components/ButtonSecondary.vue'

export default {
  components: { NiveauQuiz, ButtonSecondary },
}
</script>

<style lang="scss" scoped>
.backBtnWrapper {
  display: flex;
  justify-content: center;
  margin: 1.5rem auto 2rem;
}

.backBtn {
  transform: scale(0.75);
  transform-origin: center;
}

ul {
  list-style: none;
  text-align: left;
}

ul li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}



.checklistTitle {
  font-size: 1.1rem;
  font-weight: 700;
  margin-top: 2rem;
  margin-bottom: 0.75rem;
  color: $accentColor;
}
.checklistNote {
  font-size: 20px;
  margin-bottom: 0.5rem;
}

.checklistNoteStrong {
  font-weight: 700;
}
.linkWithIcon {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: $linkColor;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.linkIcon {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.infoIcon {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  margin-right: 3px;
}

.infoNote {
  position: relative;
  display: inline-block;
  max-width: 800px;
  margin: 0 auto 1.5rem;
  padding: 0.85rem 1.2rem 0.85rem 1.4rem;
  font-size: 18px;
  font-style: italic;
  color: #333;
  background: #fffaec;
  border-radius: 0 8px 8px 0;
  text-align: left;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: $accentGold;
    border-radius: 3px 0 0 3px;
  }
}

ul li::before {
  content: "";
  display: inline-block;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  background-image: url("../assets/image/icons/material-symbols_check-box_yellow.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

@media (max-width: 767px) {
  ul li {
    display: block;
  }

  ul li::before {
    vertical-align: middle;
    margin-right: 6px;
    margin-top: 0;
  }

  .infoNote {
    display: block;
    max-width: 100%;
    box-sizing: border-box;
  }
}
</style>